import React from 'react';
import { LogIn, ArrowLeft } from 'lucide-react';

const ImpersonationBanner = () => {
  const adminToken = localStorage.getItem('admin_token');
  if (!adminToken) return null;

  let adminUser;
  try {
    adminUser = JSON.parse(localStorage.getItem('admin_user') || '{}');
  } catch {
    adminUser = {};
  }

  const handleReturnToAdmin = () => {
    localStorage.setItem('token', adminToken);
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    window.location.href = '/admin';
  };

  return (
    <div data-testid="impersonation-banner">
      <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-white text-sm flex items-center justify-center gap-3 py-2 px-4 shadow-lg">
        <LogIn className="w-4 h-4" />
        <span>Mode support — Vous etes connecte en tant qu'un autre utilisateur</span>
        <button
          data-testid="return-to-admin-btn"
          onClick={handleReturnToAdmin}
          className="ml-2 inline-flex items-center gap-1 bg-white text-amber-700 font-semibold px-3 py-1 rounded hover:bg-amber-50 transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Retour Admin ({adminUser.name || adminUser.email || 'Admin'})
        </button>
      </div>
      <div className="h-10" />
    </div>
  );
};

export default ImpersonationBanner;
